import { SaasControl } from "~/components/admin/saas-control";

export const SaasControlScreen = () => {
  return <SaasControl />;
};
